module.exports = __webpack_public_path__ + "img/img_pedia_large@2x.7d33d8a0.png";